import React from 'react';
import Contact from '../Contact';

export const Privacy = () => {
  const styles = {
    container: {
      minHeight: '100vh',
      backgroundColor: '#f8f9fa',
      padding: '40px 20px'
    },
    header: {
      textAlign: 'center',
      marginBottom: '50px'
    },
    title: {
      fontSize: '2.5rem',
      fontWeight: 'bold',
      color: '#2c3e50',
      marginBottom: '15px'
    },
    subtitle: {
      fontSize: '1.1rem',
      color: '#7f8c8d'
    },
    card: {
      backgroundColor: 'white',
      borderRadius: '12px',
      padding: '30px',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      marginBottom: '30px'
    },
    sectionTitle: {
      fontSize: '1.5rem',
      fontWeight: '600',
      color: '#2c3e50',
      marginBottom: '20px',
      borderBottom: '3px solid #3498db',
      paddingBottom: '10px'
    },
    faqItem: {
      marginBottom: '20px',
      padding: '15px',
      backgroundColor: '#f8f9fa',
      borderRadius: '8px',
      borderLeft: '4px solid #3498db'
    },
    faqQuestion: {
      fontWeight: '600',
      color: '#2c3e50',
      marginBottom: '8px',
      fontSize: '1.05rem'
    },
    faqAnswer: {
      color: '#7f8c8d',
      lineHeight: '1.6'
    },
    contactMethod: {
      display: 'flex',
      alignItems: 'center',
      padding: '20px',
      backgroundColor: '#f8f9fa',
      borderRadius: '8px',
      marginBottom: '15px'
    },
    contactIcon: {
      fontSize: '2rem',
      marginRight: '20px',
      color: '#3498db'
    },
    contactInfo: {
      flex: 1
    },
    contactTitle: {
      fontWeight: '600',
      color: '#2c3e50',
      marginBottom: '5px'
    },
    contactDetail: {
      color: '#7f8c8d',
      marginBottom: '3px'
    },
    row: {
      display: 'flex',
      flexWrap: 'wrap',
      margin: '0 -15px'
    },
    col: {
      flex: '0 0 100%',
      maxWidth: '100%',
      padding: '0 15px',
      boxSizing: 'border-box'
    },
    infoSection: {
      marginBottom: '25px'
    },
    infoText: {
      color: '#555',
      lineHeight: '1.8',
      fontSize: '1rem',
      marginBottom: '15px'
    },
    hoursTable: {
      width: '100%',
      marginTop: '15px'
    },
    hoursRow: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '10px 0',
      borderBottom: '1px solid #e0e0e0'
    },
    dayLabel: {
      fontWeight: '500',
      color: '#2c3e50'
    },
    timeLabel: {
      color: '#7f8c8d'
    }
  };

  const colStyle = window.innerWidth >= 768 ? {
    ...styles.col,
    flex: '0 0 50%',
    maxWidth: '50%'
  } : styles.col;

  return (
    <>
    <br />
    <br />
    <br />
    <div style={styles.container}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={styles.header}>
          <h1 style={styles.title}>Privacy Policy</h1>
          <p style={styles.subtitle}>We're here to help! Find answers to common questions and learn how to reach us.</p>
        </div>

        <div style={styles.row}>
          <div style={colStyle}>
            <div style={styles.card}>
              <h2 style={styles.sectionTitle}>Contact Information</h2>
              
              <div style={styles.infoSection}>
                <p style={styles.infoText}>
                  Our dedicated support team is ready to assist you with any questions or concerns. 
                  We offer multiple ways to get in touch based on your preference and urgency.
                </p>
              </div>

              <div style={styles.contactMethod}>
                <div style={styles.contactIcon}>📧</div>
                <div style={styles.contactInfo}>
                  <div style={styles.contactTitle}>Email Support</div>
                  <div style={styles.contactDetail}>support@foxtroit.in</div>
                  <div style={styles.contactDetail}>Response time: Within 24 hours</div>
                </div>
              </div>

              <div style={styles.contactMethod}>
                <div style={styles.contactIcon}>📞</div>
                <div style={styles.contactInfo}>
                  <div style={styles.contactTitle}>Phone Support</div>
                  <div style={styles.contactDetail}>+91 9861632429</div>
                  <div style={styles.contactDetail}>Mon-Fri: 10:00 AM - 6:00 PM IST</div>
                </div>
              </div>


              <div style={styles.contactMethod}>
                <div style={styles.contactIcon}>📍</div>
                <div style={styles.contactInfo}>
                  <div style={styles.contactTitle}>Office Address</div>
                  <div style={styles.contactDetail}>MR building, 3rd floor</div>
                  <div style={styles.contactDetail}> Hbr layout, Hennur Cross</div>
                  <div style={styles.contactDetail}>Bangalore, Karnataka, 560043, India</div>
                </div>
              </div>
            </div>
          </div>

          <div style={colStyle}>
           <div style={styles.card}>

  <div style={styles.faqItem}>
    <div style={styles.faqQuestion}>1. Information We Collect</div>
    <div style={styles.faqAnswer}>
      We may collect:<br /><br />
      • Personal details such as name, email address, phone number, or company name when you contact us or register.<br />
      • Technical data like IP address, browser type, and cookies to enhance user experience.<br />
      • Usage data related to how you interact with our AI platforms and services.
    </div>
  </div>

  <div style={styles.faqItem}>
    <div style={styles.faqQuestion}>2. How We Use Your Information</div>
    <div style={styles.faqAnswer}>
      We use your data to:<br /><br />
      • Deliver and improve our AI products and services.<br />
      • Communicate updates, respond to inquiries, and provide support.<br />
      • Analyze trends and user behavior to enhance performance.<br />
      • Ensure compliance with legal obligations.
    </div>
  </div>

  <div style={styles.faqItem}>
    <div style={styles.faqQuestion}>3. Data Protection</div>
    <div style={styles.faqAnswer}>
      Your information is stored securely and accessed only by authorized personnel.<br />
      We implement encryption, access control, and monitoring to prevent unauthorized access, alteration, or disclosure.
    </div>
  </div>

  <div style={styles.faqItem}>
    <div style={styles.faqQuestion}>4. Sharing of Information</div>
    <div style={styles.faqAnswer}>
      We do not sell or trade your personal data.<br />
      We may share data only with trusted third parties (e.g., hosting partners or service providers) under strict confidentiality agreements.
    </div>
  </div>

  <div style={styles.faqItem}>
    <div style={styles.faqQuestion}>5. Your Rights</div>
    <div style={styles.faqAnswer}>
      You have the right to:<br /><br />
      • Request access or correction of your personal data.<br />
      • Withdraw consent for data processing.<br />
      • Request deletion of stored information (subject to applicable laws).
    </div>
  </div>

  <div style={styles.faqItem}>
    <div style={styles.faqQuestion}>6. Updates</div>
    <div style={styles.faqAnswer}>
      This policy may be updated periodically.<br />
      Changes will be reflected on this page with an updated “Effective Date.”
    </div>
  </div>

</div>

          </div>
        </div>
      </div>
    </div>
    <Contact />
    </>
  );
};

export default Privacy;